<template>
  <div
    ref="swiper"
    class="swiper"
    :style="{
      ...webStyle,
      flex: 1,
      display: 'block',
      position: 'relative',
      boxSizing: 'border-box',
      overflowX: 'hidden',
    }"
    @touchstart="touchstart"
    @touchmove="touchmove"
    @touchend="touchend"
  >
    <div
      :class="{'swiper-animation': needAnimation && hasAnimation}"
      :style="{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        width: 100 * slideSlideLength + '%',
        flex: 0,
        position: 'relative',
        transform: transformValue,
        height: '100%',
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Swiper',
  props: {
    current: {
      type: Number,
      default: 0,
    },
    needAnimation: {
      type: Boolean,
      default: true,
    },
    recycle: {
      type: Boolean,
      default: false,
    },
    // 回收情况下一次展示多少个
    showNum: {
      type: Number,
      default: 3,
      validator: num => num >= 3,
    },
    webStyle: {
      type: Object,
      default: () => { },
    },
    direction: {
      type: String,
      default: 'row',
      validator: direction => ['row', 'column'].includes(direction),
    },
    noTouch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      slideIndex: this.current,

      slideSlideLength: 0,

      transformValue: 'translate3d(0, 0, 0)',
      swiperWidth: 0,

      startX: 0,
      startY: 0,

      swiperRight: 0,
      swiperBottom: 0,

      offsetX: 0,
      offsetY: 0,

      swiperPadding: 0,
      swiperPaddingTop: 0,

      hasAnimation: false,
      slideScale: 0.35,
      isRow: this.direction === 'row',
    };
  },
  watch: {
    current(newV) {
      this.hasAnimation = true;
      this.slideIndex = newV;
      this.slideToIndex();
    },
  },
  created() {
    this.swiperLength = this.$slots?.default?.length;
    this.recycle && this.$on('updatePadding', (num) => {
      if (this.isRow) {
        this.swiperPadding += +num;
      } else {
        this.swiperPaddingTop += +num;
      }
    });
  },
  mounted() {
    this.slideSlideLength = this.$children.length;
    this.updateInfo();
  },
  methods: {
    updateInfo() {
      if (this.swiperWidth || this.swiperHeight) {
        return;
      }
      if (this.isRow) {
        this.swiperWidth = this.$refs.swiper.clientWidth;
        this.swiperRight = this.swiperWidth * this.current;
      } else {
        // column
        this.swiperHeight = this.$refs.swiper.clientHeight || parseFloat(this.customStyle.height);
        this.swiperBottom = this.swiperHeight * this.current;
      }
    },
    setSlide(newV) {
      this.hasAnimation = true;
      this.slideIndex = newV;
      console.log(newV);
      console.log('slideToIndex');
      this.slideToIndex();
      this.$emit('dropped', this.createEvent({
        currentSlide: this.slideIndex,
      }));
    },
    touchstart(event) {
      this.updateInfo();
      console.log('touchstart');
      if (this.noTouch) {
        return;
      }
      this.hasAnimation = false;
      this.startX = event.touches && event.touches[0].clientX;
      this.startY = event.touches && event.touches[0].clientY;
      // 记录滑动初始值
      this.startRight = this.swiperRight;
      this.startBottom = this.swiperBottom;
      this.offsetX = 0; // 清掉上一次滑动记录
    },
    touchmove(event) {
      console.log('touchmove');
      if (this.noTouch) {
        return;
      }
      const touch = event.touches && event.touches[0];
      this.offsetX = this.startX - touch.clientX;
      this.offsetY = this.startY - touch.clientY;
      console.log('this.offsetX', this.offsetX);
      this.$emit('dragging', event);
      if (this.isRow) {
        if ((this.offsetX < 0 && this.slideIndex === 0)
            || (this.offsetX > 0 && this.slideIndex === this.slideSlideLength - 1)
        ) {
          // 最左和最右的情况
          this.offsetX = 0;
        } else {
          console.log('this.startRight', this.startRight);
          this.transformValue = `translate3d(${(this.startRight + this.offsetX) * -1}px, 0, 0)`;
          this.swiperRight = this.startRight + this.offsetX;
        }
        this.transformValue = `translate3d(${(this.startRight + this.offsetX) * -1}px, 0, 0)`;
        this.swiperRight = this.startRight + this.offsetX;
      } else if ((this.offsetY < 0 && this.slideIndex === 0)
          || (this.offsetY > 0 && this.slideIndex === this.slideLength - 1)
      ) {
        // 最上和最下的情况
        this.offsetY = 0;
      } else {
        this.swiperBottom = this.startBottom + this.offsetY;
      }
    },
    touchend(event) {
      if (this.noTouch) {
        return;
      }
      if (this.isRow) {
        if (this.offsetX > this.swiperWidth * this.slideScale) {
          this.hasAnimation = true;
          this.slideIndex += 1;
          this.slideToIndex();
          this.$emit('dropped', this.createEvent({
            ...event,
            currentSlide: this.slideIndex,
          }));
        } else if (this.offsetX < -this.swiperWidth * this.slideScale) {
          this.hasAnimation = true;
          this.slideIndex -= 1;
          this.slideToIndex();
          this.$emit('dropped', this.createEvent({
            ...event,
            currentSlide: this.slideIndex,
          }));
        } else {
          // 滑的比例不够，不换页处理
          this.hasAnimation = true;
          this.slideToIndex();
        }
      } else {
        // 虽然差不多，但先分开写，避免有差异化产生
        // console.log('test', this.offsetY, this.swiperHeight)
        if (this.offsetY > this.swiperHeight * this.slideScale) {
          this.hasAnimation = true;
          this.slideIndex += 1;
          this.slideToIndex();
          this.$emit('dropped', this.createEvent({
            ...event,
            currentSlide: this.slideIndex,
          }));
        } else if (this.offsetY < -this.swiperHeight * this.slideScale) {
          this.hasAnimation = true;
          this.slideIndex -= 1;
          this.slideToIndex();
          this.$emit('dropped', this.createEvent({
            ...event,
            currentSlide: this.slideIndex,
          }));
        } else {
          this.hasAnimation = true;
          this.slideToIndex();
        }
      }
    },
    createEvent(event) {
      event.stopPropagation = () => {};
      return event;
    },
    slideToIndex() {
      this.$nextTick(() => {
        if (this.isRow) {
          this.swiperRight = this.swiperWidth * this.slideIndex;
          // console.log(`translate3d('${this.swiperWidth * this.slideIndex * -1}px', 0, 0)`);
          this.transformValue = `translate3d(${this.swiperWidth * this.slideIndex * -1}px, 0, 0)`;
        } else {
          this.swiperBottom = this.swiperHeight * this.slideIndex;
        }
      });
    },
  },
};
</script>

<style lang="less">
.swiper {
  display: block!important;
}
.swiper-animation {
  transition: transform 0.3s ease-in-out;
}
</style>
